"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { matchesMarketplacePreviewCanonicalId, patchFromMediaLinkUpdate, type MarketplacePreviewData } from "@/components/waves/marketplace/common";
import type { WsMediaLinkUpdatedData } from "@/helpers/Types";
import { WsMessageType } from "@/helpers/Types";
import { useWebSocketMessage } from "./useWebSocketMessage";
const isMediaLinkUpdatedData = (value: unknown): value is WsMediaLinkUpdatedData => {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }
  return "canonical_id" in value && typeof (value as {
    canonical_id?: unknown;
  }).canonical_id === "string";
};
export function MarketplacePreviewWebSocketSync() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = message => {
      if (!isMediaLinkUpdatedData(message)) {
        return;
      }
      queryClient.setQueriesData({
        queryKey: [QueryKey.MARKETPLACE_PREVIEW]
      }, current => {
        if (!current) {
          return current;
        }
        if (!matchesMarketplacePreviewCanonicalId({
          previewCanonicalId: current.canonicalId,
          incomingCanonicalId: message.canonical_id
        })) {
          return current;
        }
        return patchFromMediaLinkUpdate({
          current,
          update: message
        });
      });
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onMediaLinkUpdated = t0;
  useWebSocketMessage(WsMessageType.MEDIA_LINK_UPDATED, onMediaLinkUpdated);
  return null;
}